var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.93438V2.66666L10.3058 2.66758L4.6116 2.66848L2.3058 5.29203C1.03761 6.73499 0 7.92407 0 7.93446C0 7.94482 1.03761 9.13392 2.3058 10.5769L4.6116 13.2004L10.3058 13.2013L16 13.2021V7.93438ZM14.819 7.93442L14.819 3.84768H9.98286L5.14675 3.84768L3.36444 5.87328C2.38416 6.98737 1.57786 7.90997 1.57267 7.92351C1.56723 7.93768 2.3222 8.81094 3.35053 9.97993L5.13783 12.0117L9.97841 12.0164L14.819 12.0212V7.93442ZM12.1149 9.99185L12.5319 9.57482L11.7118 8.75461L10.8918 7.93438L11.7165 7.10952L12.5412 6.28469L12.1241 5.86765L11.7071 5.45062L10.8823 6.27531L10.0574 7.1L9.23255 6.27531L8.40771 5.45062L7.99068 5.86765L7.57365 6.28469L8.39834 7.10952L9.22303 7.93438L8.39834 8.75924L7.57365 9.58408L7.99068 10.0011L8.40771 10.4181L9.23255 9.59345L10.0574 8.76876L10.8776 9.58882L11.6978 10.4089L12.1149 9.99185Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseTag);
export default __webpack_public_path__ + "static/media/icon--close-tag.23debc7c47a64b996d216699f960b4cd.svg";
export { ForwardRef as ReactComponent };